import React from "react";
import { Link } from "react-router-dom";
import Button from "../ui/button";

const isInternalPath = (href) =>
  typeof href === "string" && href.startsWith("/");
const isHashAnchor = (href) => typeof href === "string" && href.startsWith("#");

const ServiceCtaButton = ({ cta, ...buttonProps }) => {
  if (!cta || !cta.href || !cta.label) {
    return null;
  }

  if (isInternalPath(cta.href)) {
    return (
      <Button
        as={Link}
        to={cta.href}
        onClick={() => window.scrollTo(0, 0)}
        {...buttonProps}
      >
        {cta.label}
      </Button>
    );
  }

  if (isHashAnchor(cta.href)) {
    return (
      <Button as="a" href={cta.href} {...buttonProps}>
        {cta.label}
      </Button>
    );
  }

  return (
    <Button
      as="a"
      href={cta.href}
      target="_blank"
      rel="noopener noreferrer"
      {...buttonProps}
    >
      {cta.label}
    </Button>
  );
};

export default ServiceCtaButton;
